import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
class ReportDetail extends React.Component {
    constructor(props)
    {
        super(props);
        
    }

    render() {
        return (
            <div className="item-detail">
                  <div className="report-items">
                                    <div className="head custom-report-head">
                                        <div className="item custom-invoice-report-detail-item">
                                            <div>Sanal Numara</div>
                                            <div>Customer ID</div>
                                            <div>Hesap No</div>
                                            <div>Müşteri Adı</div>
                                            <div>Mesaj Başlığı</div>
                                            <div>SMS Atılan Tarih</div>
                                            <div>Başarılı İletilen Abone Sayısı</div>
                                            <div>Başarılı Mesaj Adedi</div>
                                            <div>Bekleyen Mesaj Adedi</div>
                                            <div>Başarısız Mesaj Adedi</div>
                                        </div>
                                    </div>
                                    <div className="body">
                                    {this.props.items.map((item, i) =>
                                            <div className="item custom-invoice-report-detail-item">
                                                <div>
                                                    <span className="label">Sanal Numara</span>
                                                    <span>{item.companyMsisdn}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Customer ID</span>
                                                    <span>{item.companyId}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Hesap No</span>
                                                    <span>{item.code}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Müşteri Adı</span>
                                                    <span>{item.accountName}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Mesaj Başlığı</span>
                                                    <span>{item.originator}</span>
                                                </div>
                                                <div>
                                                    <span className="label">SMS Atılan Tarih</span>
                                                    <span>{moment(item.date).format('DD.MM.YYYY')}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarılı İletilen Abone Sayısı</span>
                                                    <span>{item.success}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarılı Mesaj Adedi</span>
                                                    <span>{item.smsTotal}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Bekleyen Mesaj Adedi</span>
                                                    <span>{item.pending}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarısız Mesaj Adedi</span>
                                                    <span>{item.failedTotal}</span>
                                                </div>
                                            </div>
                                    )}
                                    </div>
                                </div>
                          
                </div>
      );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}

export default connect(mapStateToProps)(ReportDetail)